import * as imageResizer from 'ls-common-client/dist/imageResizer';
import config from '../../src/client/config';

const instance = imageResizer.create(config);

const { resize } = instance;

export { resize };

export default instance;
